import client from './client';

export const login = (user, pass) => client.post('/auth/login', { user, pass }).then((r) => r.data);
export const me = () => client.get('/auth/me').then((r) => r.data);
export const updateProfile = (payload) => client.put('/auth/profile', payload).then((r) => r.data);
export const changePassword = (payload) => client.put('/auth/password', payload).then((r) => r.data);
export const firstSetup = (payload) => client.post('/auth/first-setup', payload).then((r) => r.data);
